<template>
  <div class="npa-promotion-history__form">
    <v-btn class="btn-add-category btn-add-history" @click.native.stop="editNpaPromotionHistory">
      <img v-if="npaPromotionHistoryEdit" src="@/assets/edit.png" alt="edit-icon">
      <span v-if="!npaPromotionHistoryEdit" class="pro-icon-add"></span> <span
      v-if="!npaPromotionHistoryEdit">{{ $t('Добавить историю') }}</span>
      <slot></slot>
    </v-btn>
    <v-dialog v-model="npaPromotionHistoryDialog" max-width="900">
      <v-card class="modal npa-promotion-history-modal">
        <div class="modal-head">
          <template v-if="!npaPromotionHistoryEdit">
            {{ $t('Добавление') }}
          </template>
          <template v-else>
            {{ $t('Редактирование') }}
          </template>
          <v-btn color="modal-close" @click.native="resetNpaPromotionHistoryAdd(false)">
            <span class="pro-icon-close1"></span>
          </v-btn>
        </div>
        <div class="modal-body">
          <v-form
            class="form-ru"
            ref="form"
            v-model="valid"
            lazy-validation
            @submit.prevent="createNpaPromotionHistory"
          >
            <div class="form-group">
              <div class="row" :class="{ invalid: $v.npaConsiderationStage.id.$error }">
                <div class="col-sm-3">
                  <label for="stage">
                    {{ $t("Стадия") }}
                    <span class="asterix">*</span>
                  </label>
                </div>
                <div class="col-sm-9">
                  <v-select
                    id="stage"
                    item-text="transName"
                    v-model="npaConsiderationStage"
                    :items="refNpaConsiderationStage"
                    input="transName"
                    @change="onChangeStage"
                    outlined
                    rounded
                    dense
                    return-object
                  ></v-select>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="npaConsiderationStage.description_type">
              <div class="row" :class="{ invalid: $v.npaPromotionHistory.description.$error }">
                <div class="col-sm-3">
                  <label for="text">
                    {{ npaConsiderationStage.description_type.transName }}
                    <span class="asterix">*</span>
                  </label>
                </div>
                <div class="col-sm-9">
                  <v-textarea
                    v-model="npaPromotionHistory.description"
                    outlined
                    :placeholder="$t('на официальном языке')"
                  />
                </div>
              </div>
            </div>
            <div class="form-group" v-if="npaConsiderationStage.description_type">
              <div class="row">
                <div class="col-sm-3">
                  <label for="text">
                  </label>
                </div>
                <div class="col-sm-9">
                  <v-textarea
                    v-model="npaPromotionHistory.descriptionKg"
                    outlined
                    :placeholder="$t('на государственном языке')"
                  />
                </div>
              </div>
            </div>
            <div class="form-group" v-if="npaConsiderationStage.date">
              <div class="row">
                <div class="col-sm-3">
                  <label for="stage">
                    {{ $t("Дата") }}
                    <span class="asterix">*</span>
                  </label>
                </div>
                <div class="col-sm-9">
                  <div class="form-date">
                    <v-menu
                      v-model="datemenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          id="npa_publishDate"
                          v-model="npaPromotionHistory.date"
                          readonly
                          v-on="on"
                          outlined
                          rounded
                          dense
                        />
                      </template>
                      <v-date-picker
                        v-model="npaPromotionHistory.date"
                        @input="datemenu = false"
                        no-title
                        :weekday-format="getDay"
                        :month-format="getMonthFormat"
                        :header-date-format="getHeaderDateFormat"
                        first-day-of-week="1"
                      />
                    </v-menu>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="!npaPromotionHistoryEdit && npaConsiderationStage.documents_upload">
              <div class="row">
                <div class="col-sm-3">
                  <label for="documents">
                    {{ $t("Документы") }}
                  </label>
                </div>
                <div class="col-sm-9">
                  <v-btn class="btn-add-category" @click.native.stop="addDocument">
                    <span class="pro-icon-add"></span>
                  </v-btn>
                  <div v-for="(input, i) in uploadedFiles" :key="i">
                    <div class="form-group">
                      <div class="row">
                        <div class="col-sm-3">
                          <label for="documentType">
                            {{ $t("Тип документа") }}
                          </label>
                        </div>
                        <div class="col-sm-9" :class="{invalid: $v.uploadedFiles.$each[i].documentType.$error}">
                          <v-select
                            id="documentType"
                            item-value="id"
                            item-text="transName"
                            v-model="input.documentType"
                            :items="refDocumentType"
                            input="transName"
                            outlined
                            rounded
                            dense
                          ></v-select>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="row">
                        <div class="col-sm-3">
                          <label for="file">
                            {{ $t("Файл") }}
                          </label>
                        </div>
                        <div class="col-sm-9" :class="{invalid: $v.uploadedFiles.$each[i].uploadedFile.$error}">
                          <div class="file-item">
                            <div class="file-item_flex">
                              <i
                                role="button"
                                class="v-icon notranslate v-icon--link mdi mdi-paperclip theme--light"
                              ></i>
                              <v-file-input
                                :label="$t('Выберите файл')"
                                v-model="input.uploadedFile"
                                class="v-input__control"
                              >
                              </v-file-input>
                              <v-btn class="btn-add btn-delete" @click.native.stop="removeDocument(i)">
                                <v-icon>delete_forever</v-icon>
                              </v-btn>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-action">
              <button
                class="btn btn-default blue"
                type="submit"
              >
                {{ $t('Сохранить') }}
              </button>
              <button
                class="btn btn-default white"
                type="button"
                @click="resetNpaPromotionHistoryAdd(false)"
              >
                {{ $t('Отмена') }}
              </button>
            </div>

          </v-form>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapMutations} from 'vuex'
import Npa from '@/model/npa'
import mixin from '@/plugins/mixin/mixin'
import {required, requiredIf} from 'vuelidate/lib/validators'
import { Trans } from "@/plugins/Translation"

export default {
  mixins: [mixin],
  props: {
    npaId: Number,
    npaPromotionHistories: Array,
    npaPromotionHistoryId: {
      type: Number,
      default: null
    },
    npaPromotionHistoryEdit: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    listLocal: {
      get() {
        return this.npaPromotionHistories
      },
      set(newList) {
        this.$emit('update:npaPromotionHistories', newList)
      }
    }
  },
  data: () => ({
    refNpaConsiderationStage: [],
    refDocumentType: [],
    npaPromotionHistoryDialog: false,
    datemenu: false,
    valid: true,
    npaPromotionHistory: {},
    npaConsiderationStage: {},
    uploadedFiles: [],
    requiredDoc: false,
    npaDocumentsFileError: false,
    rules: {
      npaPromotionHistory: {
        description: {
          required: requiredIf(function () {
            return this.npaConsiderationStage.description_type
          })
        }
      },
      npaConsiderationStage: {
        id: {required}
      },
      uploadedFiles: {
        $each: {
          uploadedFile: {
            required: requiredIf(function () {
              return this.requiredDoc === true
            })
          },
          documentType: {
            required: requiredIf(function () {
              return this.requiredDoc === true
            })
          }
        }
      }
    },
  }),
  validations() {
    return this.rules
  },
  methods: {
    createNpaPromotionHistory() {
      if (!this.validateForm()) return

      if (!this.npaPromotionHistoryId) {
        const f = this.$refs.form.$el
        const formData = new FormData(f)

        formData.append('npa_promotion_history[npaConsiderationStage]', this.npaConsiderationStage.id)

        if (this.npaConsiderationStage.description_type) {
          formData.append('npa_promotion_history[description]', this.npaPromotionHistory.description)
          formData.append('npa_promotion_history[descriptionKg]', this.npaPromotionHistory.descriptionKg)
        }

        if (this.npaConsiderationStage.date === true) {
          formData.append('npa_promotion_history[date]', this.npaPromotionHistory.date)
        }

        if (this.npaConsiderationStage.documents_upload && this.uploadedFiles) {
          this.uploadedFiles.forEach(function (element, index) {
            formData.append(`npa_promotion_history[npaPromotionHistoryDocuments][${index}][uploadedFile]`, element.uploadedFile)
            formData.append(`npa_promotion_history[npaPromotionHistoryDocuments][${index}][documentType]`, element.documentType)
          })
        }

        Npa.createNpaPromotionHistory(this.npaId, formData)
          .then((res) => {
            if (res.status === 201) {
              this.resetNpaPromotionHistoryAdd(false)
              this.listLocal = res.data.npaPromotionHistories
            }
          })
          .catch((err) => {
            if (err.response) {
              if (err.response.data.npaPromotionHistoryForm) {
                if (err.response.data.npaPromotionHistoryForm) {
                  let npaPromotionHistoryForm = err.response.data.npaPromotionHistoryForm
                  const message = npaPromotionHistoryForm.data.errors.errors[0]
                  this.$noty.error(this.$i18n.t(message), {
                    killer: true,
                    timeout: 1000,
                    layout: 'topRight'
                  })
                }
              }
            }
          })
      } else {
        const editedData = {}
        editedData.npaConsiderationStage = this.npaConsiderationStage.id
        if (this.npaConsiderationStage.description_type) {
          editedData.description = this.npaPromotionHistory.description
          editedData.descriptionKg = this.npaPromotionHistory.descriptionKg
        }
        if (this.npaConsiderationStage.date === true) {
          editedData.date = this.npaPromotionHistory.date
        }

        Npa.updateNpaPromotionHistory(this.npaPromotionHistoryId, editedData)
          .then((res) => {
            if (res.status === 202) {
              this.resetNpaPromotionHistoryAdd(false)
              this.listLocal = res.data.npaPromotionHistories
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    editNpaPromotionHistory() {

      Npa.getNpaPromotionHistoryFormData(this.npaId)
        .then((res) => {
          this.refNpaConsiderationStage = res.data.refNpaConsiderationStage
          this.refDocumentType = res.data.refDocumentType
        })
        .catch((err) => {
          this.$router.push(Trans.i18nRoute({
            name: 'error',
            params: {
              status: err.response.status
            }
          }))
        })

      if (this.npaPromotionHistoryEdit && this.npaPromotionHistoryId) {
        Npa.getEdit(this.npaPromotionHistoryId)
          .then((res) => {
            this.npaPromotionHistory = res.data
            this.npaConsiderationStage = this.npaPromotionHistory.npaConsiderationStage
            delete this.npaPromotionHistory.npaConsiderationStage
            this.npaPromotionHistoryDialog = true
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
        this.resetNpaPromotionHistoryAdd(true)
      }
    },
    resetNpaPromotionHistoryAdd(flag) {
      this.npaPromotionHistoryDialog = flag
      this.npaPromotionHistory = {}
      this.npaConsiderationStage = {}
      this.uploadedFiles = []
      this.$v.$reset()
    },
    onChangeStage() {
      this.npaPromotionHistory = {}
      this.uploadedFiles = []
    },
    // Валидация формы
    validateForm() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => {
          this.scrollToFirstError()
        })

        return false
      }

      return true
    },
    addDocument() {
      this.requiredDoc = true
      this.uploadedFiles.push({
        uploadedFile: [],
        documentType: ''
      })
    },
    removeDocument(index) {
      this.uploadedFiles.splice(index, 1);
    },
    scrollToFirstError() {
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
        (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
        (document.body.scrollTop || document.documentElement.scrollTop) -
        90
      )
    }
  }

}
</script>

<style lang="scss" scoped>
.col-sm-2,
.col-sm-3,
.col-sm-9,
.col-sm-10 {
  padding-top: 0px;
  padding-bottom: 0px;
}

.form-files {
  label {
    min-width: auto;
  }
}

.files {
  .file-item {
    display: flex;

    i {
      position: relative;
      top: -4px;
    }

    .v-input {
      max-width: 240px;
      margin: 0;
      padding: 0;
      white-space: nowrap;
    }
  }
}
</style>

